var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-box"},[_c('i',{staticClass:"icon iconfont iconzhanwei"}),_c('p',{staticClass:"empty-message"},[_vm._v("No Data")])])}]

export { render, staticRenderFns }